import React, { useEffect, useState } from 'react'
import Cell from '../cell'
import Checkbox from '../../../ui/checkbox/checkbox'
import ProductSetLabel from '../../../productSetLabel/ProductSetLabel'
import { DrawingElement } from './drawingElement'
import { emmiter } from '../../../../helpers/Emmiter'
import { RemoteStockLabel } from '../../../remote-stock-label/remoteStockLabel'

export const PositionRowItem = (
  {
    position,
    isSelected,
    c_position_ID,
    onSelectPosition,
    onOpenSetModal,
    onPositionDetail,
    editMode,
    onSelectDrawing,
    selectedDrawings,
    onSetEditMode,
    setHoveredUnionHash,
    hoveredUnionHash,
    onUnionDelete,
    getData,
    isHeadOfProduction,
    remoteStockName,
    isCurrentStageForRemoteLabel,
    stageStepForRemoteLabel
  }
) => {

  const {
    id,
    link,
    isUrgent,
    quantity,
    quantityInStock,
    quantityUnderOrder,
    c_position_stages,
    drawings,
    image,
    code,
    title,
    kitID,
    boxCount
  } = position

  const [selectedDrawingsID, setSelectedDrawingsID] = useState(null)
  const {isActive, currentUnionHash, currentDrawingCode, existsUnionEdit} = editMode

  useEffect(() => {
    if(!editMode.isActive) {
      setSelectedDrawingsID(null)
    }
    const allSelectedDrawingsIDs = Object.keys(selectedDrawings).map(id => Number(id))
    const currentPositionDrawings = drawings.map(d => d.id)

    const isThisPositionDrawingSelected = allSelectedDrawingsIDs.some((id) => currentPositionDrawings.includes(id))

    if(isThisPositionDrawingSelected) {
      currentPositionDrawings.forEach((thisPositionDrawingID) => {
        const selectedID = allSelectedDrawingsIDs.find((globalSelectedDrawingID) => globalSelectedDrawingID === thisPositionDrawingID)
        if(selectedID) {
          setSelectedDrawingsID(selectedID)
        }
      })
    } else {
      setSelectedDrawingsID(null)
    }
  }, [selectedDrawings])

  const setSelectedCode = (data) => {
    onSelectDrawing(data)
  }

  const drawingsRender = drawings?.map((drawing, _, arr) => {
      const arrLength = arr.length
      return (
        <DrawingElement
          onUnionDelete={onUnionDelete}
          setHoveredUnionHash={setHoveredUnionHash}
          hoveredUnionHash={hoveredUnionHash}
          existsUnionEdit={existsUnionEdit}
          onSetEditMode={onSetEditMode}
          key={drawing.id}
          selectedDrawings={selectedDrawings}
          selectedDrawingsID={selectedDrawingsID}
          isEditActive={isActive}
          currentUnionHash={currentUnionHash}
          currentDrawingCode={currentDrawingCode}
          drawing={drawing}
          arrLength={arrLength}
          onSelectDrawing={setSelectedCode}
          isHeadOfProduction={isHeadOfProduction}
        />
      )
    })

  const onSetBoxCount = () => {
    emmiter.emmit('boxCountModal', {
      id,
      boxCount,
      title,
      getData,
    })
  }

  return (
    <div className="flex">
      <div className={`relative w-[4.8rem]
										${isUrgent
        ? 'after:absolute after:top-[0] after:left-[100%] after:bottom-0 after:w-[0.4rem] after:bg-Accent/Red'
        : ''}
									`}>
        <Cell ml="ml-[0px]" width="w-[4.8rem]"
              className={`absolute inset-0 h-auto`}>
          <Checkbox active={isSelected} onChange={() => onSelectPosition(id,
            c_position_ID)}></Checkbox>
        </Cell>
      </div>
      <Cell width="w-[10rem]" className={`min-h-[10rem] h-auto`}>
        <img src={image} alt="" className="max-h-[100%] m-auto" />
      </Cell>
      <Cell className={`min-h-[10rem] h-auto`}>
        <div className={'flex flex-col gap-[8px] items-center'}>
          {kitID &&
            <ProductSetLabel onOpenSetModal={onOpenSetModal} kitID={kitID} />}
          <span
            className="line-clamp-4 break-all text-Regular(16_18)">{code}</span>
        </div>
      </Cell>
      <Cell className={`min-h-[10rem] h-auto`}>
                      <span
                        className="line-clamp-4 text-Regular(12_14)"
                        data-tooltip-id="cell_tooltip"
                        data-tooltip-content={title}>
                        {link ? (
                          <a
                            className="underline break-all border-t-0 border-r-0 border-l-0 text-Accent/Blue hover:cursor-pointer hover:opacity-80 ease-out duration-300"
                            href={link}
                            target="_blank">
                            {title}
                          </a>
                        ) : (
                          <>{title}</>
                        )}
                      </span>
      </Cell>
      <Cell className={`min-h-[10rem] h-auto`} width={'w-[15rem]'}>
        <div className="flex flex-col items-center">
          {quantityUnderOrder && (
            <div
              className="flex gap-[0.3rem] left-[100%] bottom-[100%]  text-Regular(12_14)">
              <span
                className="text-Accent/Green"> {quantityInStock}</span>/{' '}
              <span className="text-Accent/Orange">{quantityUnderOrder}</span>
            </div>
          )}
          <span className="line-clamp-4 text-Regular(16_18)">{quantity}</span>
          <RemoteStockLabel
            remoteStockName={remoteStockName}
            isCurrentStage={isCurrentStageForRemoteLabel}
            stageStep={stageStepForRemoteLabel}
          />
        </div>
      </Cell>
      <Cell className={`min-h-[10rem] h-auto hover:cursor-pointer hover:bg-Accent/Light_Yellow`} width={'w-[10rem]'} onClick={onSetBoxCount}>
        <div className="flex flex-col items-center">
          <span className="line-clamp-4 text-Regular(16_18)">{boxCount !== null ? boxCount : '-'}</span>
        </div>
      </Cell>
      <Cell className={`min-h-[10rem] h-auto`} width={`w-[38rem]`}>
        <div className="grid gap-[0.4rem] h-[auto] overflow-auto w-[100%]">
          {drawingsRender}
        </div>
      </Cell>
      <Cell className={`min-h-[10rem] h-auto`} width={'w-[9rem]'}>
        <div className="grid gap-[0.4rem] h-[auto] w-[100%] overflow-auto">
          {drawings?.map(({ stamps, id }, _, arr) => (
            <div key={id} className="flex items-center justify-center h-[3.4rem]">
                            <span
                              className={`${arr.length == 1
                                ? 'text-Regular(16_18)'
                                : 'text-Regular(12_14)'} line-clamp-1`}>
                              {stamps || 1}
                            </span>
            </div>
          ))}
        </div>
      </Cell>
      <Cell className={`min-h-[10rem] h-auto w-[28rem]`}>
        <div className="grid gap-[0.4rem] h-[auto] overflow-auto w-[100%]">
          {drawings?.map(({ logo, id }, _, arr) => (
            <div key={id}
              className="flex items-center justify-center h-[3.4rem]">
                            <span
                              className={`${arr.length == 1
                                ? 'text-Regular(16_18)'
                                : 'text-Regular(12_14)'} line-clamp-4`}
                              data-tooltip-id="cell_tooltip"
                              data-tooltip-content={logo}>
                              {logo || '-'}
                            </span>
            </div>
          ))}
        </div>
      </Cell>
      <div
        style={{
          backgroundColor: c_position_stages[0]?.stage?.color
        }}
        className={`flex flex-col`}
      >
        <Cell className={`min-h-[10rem] h-[100%] flex-1`}>
          <span
            className="line-clamp-3 text-Regular(16_18)">{c_position_stages[0]?.stage?.title}</span>
        </Cell>
      </div>
      <Cell width="w-[4.8rem]" className={`min-h-[10rem] h-auto flex-1`}>
        <div
          onClick={() => onPositionDetail(id)}
          className="hover:cursor-pointer w-[20px] h-[20px] flex justify-center items-center">
          <i
            className="duration-300 ease-in-out hover:text-Accent/Blue icon-drag text-Regular(24_30) text-Content/Light"></i>
        </div>
      </Cell>
    </div>
  )
}